// - Name
// - Email
// - What would you like to discuss?  (short text)

import React from "react";
import styles from "./Form.module.scss";
import Cta from "../Cta";
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useCaptcha } from "../../hooks/useCaptcha";

const General = props => {
	const getCaptchaToken = useCaptcha('submit_general_form');

	const handleSubmit = async (e) => {
		e.preventDefault();
		const token = await getCaptchaToken();
		
		if (token) {
			// Set the hidden input value
			document.getElementById('g-recaptcha-response').value = token;
		}

		// Now submit the form normally
		e.target.submit();
	};

	return (
		<form action="https://usebasin.com/f/666fdccea486" method="POST" onSubmit={handleSubmit}>
			<input type="hidden" name="g-recaptcha-response" id="g-recaptcha-response" />
			<input type="hidden" name="g-recaptcha-version" value="v3" />
			<Stack spacing={1.5} mb={1} className={styles.inputWrapper}>
				<TextField type="text" id="name" name="name" label="NAME" required="required" />
				<TextField type="email" id="email" name="email" label="EMAIL ADDRESS" required="required" />
				<TextField type="text" id="discuss" name="discuss" label="WHY WOULD YOU LOVE TO WORK WITH US?" required="required" />
				<Cta type="button" color={props.background_color}>
					<input type="submit" />
				</Cta>
			</Stack>
		</form>
	);
};

export default General;
